export default __webpack_public_path__ + "static/media/Eternity.04a141a0.jpg";